// extracted by mini-css-extract-plugin
export default {"invalid":"CentralEdit_invalid__UliPN","spinnerContainer":"CentralEdit_spinnerContainer__w42v1"};